module.exports = __webpack_public_path__ + "img/corridoio 1.84252a80.jpeg";